import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// React Router ne remet pas le scroll en haut lors d'un changement de page —
// sans ça, cliquer un lien depuis le bas d'une page arrive au milieu de la suivante.
// Ignore le hash (ex. /a-propos#mot-du-pasteur) : dans ce cas on laisse le navigateur
// faire son scroll natif vers l'ancre.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
